import { useSelectedFullRoundStore, useSelectedRoundStore } from '@/store/store'
import { UserApi } from 'api/api'
import { useQuery } from 'react-query'
import { Round } from 'types/types'

const POLL_INTERVAL = 60 * 1000

// Stop polling once the round is done - it can no longer change status.
const isRoundInFlight = (round?: Round | null) =>
  !round || round.status === 'ACTIVE' || round.status === 'UPCOMING'

export const useGetRound = (id?: number, enabled = true) => {
  const [setSelectedFullRound] = useSelectedFullRoundStore((state) => [state.setSelectedRound])
  const [currentSimpleRound] = useSelectedRoundStore((state) => [state.selectedRound])

  return useQuery({
    queryKey: ['round', id ?? currentSimpleRound?.id],
    queryFn: () => UserApi.getRoundById(id ?? currentSimpleRound?.id ?? null),
    enabled,
    staleTime: POLL_INTERVAL,
    refetchInterval: (data) => (isRoundInFlight(data) ? POLL_INTERVAL : false),
    retry: 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10000),
    onSuccess: (data) => {
      if (data && enabled) {
        setSelectedFullRound(data)
      }
    },
  })
}
